import { Alert } from '@/global/components/Alert'
import { Checkbox } from '@/global/components/Checkbox'
import Dialog from 'global/guides/Dialog'
import { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { AutocompleteSegmento } from 'templates/Cadastro/Empresas/atoms/forms/DadosCadastrais/AutocompleteSegmento'

interface Item {
    id: number
    nomeFantasia: string
}

interface IProps {
    open: boolean
    titulo: string
    mensagem: string
    itens: Item[]
    onAplicar: (itens: Array<{ id: number; nome: string }>) => Promise<unknown>
}

export function AplicarSegmentoEmLote({
    open,
    titulo,
    mensagem,
    itens,
    onAplicar,
}: IProps) {
    const [modoLote, setModoLote] = useState(false)
    const [travado, setTravado] = useState(false)
    const [loading, setLoading] = useState(false)

    const methods = useForm({
        defaultValues: {
            itens: Object.fromEntries(
                itens.map(item => [item.id, { nome: '' }]),
            ),
            todas: { nome: '' },
        },
    })

    const valoresItens = methods.watch('itens')
    const algumPreenchido = itens.some(item => valoresItens?.[item.id]?.nome)

    function handleToggleModoLote() {
        const novoModoLote = !modoLote
        setModoLote(novoModoLote)
        setTravado(novoModoLote)
        if (!novoModoLote) methods.setValue('todas.nome', '')
    }

    function handleAplicarATodas(nomeEscolhido: string) {
        itens.forEach(item =>
            methods.setValue(`itens.${item.id}.nome`, nomeEscolhido),
        )
        setTravado(false)
    }

    async function handleSubmit() {
        const valores = methods.getValues('itens')
        const itensPreenchidos = itens
            .filter(item => valores[item.id]?.nome)
            .map(item => ({ id: item.id, nome: valores[item.id].nome }))

        if (itensPreenchidos.length === 0) return

        setLoading(true)
        try {
            await onAplicar(itensPreenchidos)
            methods.reset({
                itens: Object.fromEntries(
                    itens.map(item => [item.id, { nome: '' }]),
                ),
                todas: { nome: '' },
            })
            setModoLote(false)
            setTravado(false)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Dialog.Root
            width="2xl"
            open={open}
            loading={loading}
            onSubmit={handleSubmit}
            onClose={() => {}}
            disableEscapeKeyDown
        >
            <Dialog.Title>{titulo}</Dialog.Title>
            <Dialog.Content>
                <Alert severity="warning" className="mb-4">
                    {mensagem}
                </Alert>

                <FormProvider {...methods}>
                    <div className="flex items-center gap-3 mb-3">
                        <Checkbox
                            label="Marcar todas"
                            checked={modoLote}
                            onCheckedChange={handleToggleModoLote}
                        />
                        {modoLote && (
                            <div className="flex-1">
                                <AutocompleteSegmento
                                    name="todas.nome"
                                    onSelecionar={handleAplicarATodas}
                                    required={false}
                                />
                            </div>
                        )}
                    </div>

                    <div
                        className="flex flex-col gap-3"
                        style={{ maxHeight: '20rem', overflowY: 'auto' }}
                    >
                        {itens.map(item => (
                            <div
                                key={item.id}
                                className="flex items-center gap-3"
                            >
                                <span className="flex-1 truncate">
                                    {item.nomeFantasia}
                                </span>
                                <div style={{ width: '16rem' }}>
                                    <AutocompleteSegmento
                                        name={`itens.${item.id}.nome`}
                                        disabled={travado}
                                        required={false}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </FormProvider>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.PrimaryButton disabled={!algumPreenchido}>
                    Aplicar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
